import { render, staticRenderFns } from "./FrentistasPosto.vue?vue&type=template&id=39df7844&"
import script from "./FrentistasPosto.vue?vue&type=script&lang=js&"
export * from "./FrentistasPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports